import { useMemoizedFn, useSetState } from 'ahooks';
import moment from 'moment';

export const useLivPageTrigger = () => {
  // 使用useSetState统一管理所有状态
  const [state, setState] = useSetState({
    selectedTitle: '',
    selectedPlatforms: ['All Systems'],
    selectedRegion: {
      region_type: 'market',
      markets: ['255'],
      regions: [],
    },
    selectedDate: [
      moment().subtract(13, 'month').startOf('month'),
      moment().subtract(1, 'months').endOf('month'),
    ],
    selectStudio: [],
    selectYM: ['1', '2']
  });

  // 使用useMemoizedFn包装统一的状态更新方法
  const handleStateChange = useMemoizedFn((name: keyof typeof state, value: any) => {
    setState({
      [name]: value
    } as any);
  });

  // 保留原有的方法别名，同样使用useMemoizedFn
  const handleTitleChange = useMemoizedFn((title: string) => {
    handleStateChange('selectedTitle', title);
  });

  const handleComparisonChange = useMemoizedFn((values: string[]) => {
    handleStateChange('selectedPlatforms', values);
  });

  const handleRegionChange = useMemoizedFn((region: any) => {
    handleStateChange('selectedRegion', region);
  });

  const handleDateChange = useMemoizedFn((date: any) => {
    handleStateChange('selectedDate', date);
  });

  const handleStudioChange = useMemoizedFn((value: string[]) => {
    handleStateChange('selectStudio', value);
  });

  const handleYMChange = useMemoizedFn((value: string[]) => {
    handleStateChange('selectYM', value);
  });

  return {
    ...state,
    handleStateChange,
    handleTitleChange,
    handleComparisonChange,
    handleRegionChange,
    handleDateChange,
    handleStudioChange,
    handleYMChange,
  };
};
